import { render, staticRenderFns } from "./FoodCourtRestaurantList.vue?vue&type=template&id=09c01078&scoped=true"
import script from "./FoodCourtRestaurantList.vue?vue&type=script&lang=js"
export * from "./FoodCourtRestaurantList.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtRestaurantList.vue?vue&type=style&index=0&id=09c01078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c01078",
  null
  
)

export default component.exports